export const CONTENT_STATES = ["default", "loading", "empty", "error", "disabled"] as const
export type ContentState = (typeof CONTENT_STATES)[number]

export type ContentSection = {
  readonly title: string
  readonly body: string
  readonly items?: readonly string[]
}

export type ContentAction = {
  readonly href: string
  readonly label: string
}

export type PublicPageKind = "account" | "content" | "faq" | "home" | "legal" | "notices" | "partner" | "policy" | "start"

export type PublicPage = {
  readonly id: `WEB-HOME-${string}`
  readonly path: string
  readonly slug: string
  readonly kind: PublicPageKind
  readonly eyebrow: string
  readonly title: string
  readonly summary: string
  readonly version: `${number}.${number}`
  readonly updatedAt: `${number}-${number}-${number}`
  readonly states: readonly ContentState[]
  readonly sections: readonly ContentSection[]
  readonly primaryAction?: ContentAction
  readonly secondaryAction?: ContentAction
}

export type LegalParagraph = {
  readonly kind: "paragraph"
  readonly text: string
}

export type LegalList = {
  readonly kind: "ordered-list" | "unordered-list"
  readonly items: readonly string[]
}

export type LegalTable = {
  readonly kind: "table"
  readonly label: string
  readonly columns: readonly string[]
  readonly rows: readonly (readonly string[])[]
}

export type LegalBlock = LegalList | LegalParagraph | LegalTable

export type LegalSection = {
  readonly title: string
  readonly blocks: readonly LegalBlock[]
}

type LegalDocumentBase = {
  readonly slug: "terms-point" | "terms-privacy" | "terms-service"
  readonly title: string
  readonly version: `${number}.${number}`
}

export type PublishedLegalDocument = LegalDocumentBase & {
  readonly announcedAt: `${number}-${number}-${number}`
  readonly effectiveAt: `${number}-${number}-${number}`
  readonly preamble: readonly LegalBlock[]
  readonly publishable: true
  readonly sections: readonly LegalSection[]
}

export type BlockedLegalDocument = LegalDocumentBase & {
  readonly announcedAt: null
  readonly effectiveAt: null
  readonly preamble: readonly []
  readonly publishable: false
  readonly sections: readonly []
}

export type LegalDocument = BlockedLegalDocument | PublishedLegalDocument

export type Notice = {
  readonly id: string
  readonly version: string
  readonly title: string
  readonly summary: string
  readonly publishedAt: string
  readonly category: "service" | "security"
  readonly pinned: boolean
  readonly sections: readonly ContentSection[]
}

export type FaqItem = {
  readonly id: string
  readonly category: "account" | "balance" | "exchange" | "transfer"
  readonly question: string
  readonly answer: string
}
